/* eslint-disable max-len */
import Icon, { GenericIconProps } from '../Icon';

const HamburgerIcon: React.FC<GenericIconProps> = ({ className, ...props }) => {
  const svg = {
    viewBox: '0 0 24 24',
  };

  const path = [
    {
      d: 'M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75Z',
    },
    {
      d: 'M3 11.75C3 11.3358 3.33579 11 3.75 11H20.25C20.6642 11 21 11.3358 21 11.75C21 12.1642 20.6642 12.5 20.25 12.5H3.75C3.33579 12.5 3 12.1642 3 11.75Z',
    },
    {
      d: 'M3 16.75C3 16.3358 3.33579 16 3.75 16H20.25C20.6642 16 21 16.3358 21 16.75C21 17.1642 20.6642 17.5 20.25 17.5H3.75C3.33579 17.5 3 17.1642 3 16.75Z',
    },
  ];

  return <Icon {...props} className={className} svg={svg} path={path} />;
};

export default HamburgerIcon;
